import React from 'react';
import { View } from 'react-native';
import { styled, SxProp } from 'dripsy';
import { observer } from 'mobx-react-lite';

import { CommentList } from '../../business/CommentList';
import { Separator } from '../../common/Separator';
import { EmptyResultView } from '../../views/EmptyResultView';
import { useAsyncInit } from '@hooks';
import { ToastService } from '@services';
import { parseApiError } from '@utils';
import { Post } from '@models/Posts/PostModel';
import { User } from '@models/Viewer/UserModel';

const Container = styled(View)({
  flex: 1,
});

const contentContainerStyle: SxProp = {
  flexGrow: 1,
  px: '$6',
};

interface IPostViewCommentListProps {
  item: Post;
  onPressUser(user: User): void;
}

export const PostViewCommentList =
  observer<IPostViewCommentListProps>(({ item, onPressUser }) => {
    useAsyncInit(() => fetch());

    async function fetch() {
      try {
        await item.comments.fetch.run();
      } catch (error) {
        ToastService.showError(parseApiError(error).message);
      }
    }

    async function fetchMore() {
      try {
        await item.comments.fetchMore.run();
      } catch (error) {
        ToastService.showError(parseApiError(error).message);
      }
    }

    const isLoading =
      item.comments.fetch.inProgress && item.comments.isEmpty;

    return (
      <Container>
        <CommentList
          ListHeaderComponent={() => <Separator size="$5" />}
          data={item.comments.asArray}
          contentContainerSx={contentContainerStyle}
          isLoading={isLoading}
          isLoadingMore={item.comments.fetchMore.inProgress}
          isRefreshing={item.comments.fetch.inProgress}
          onRefresh={fetch}
          onEndReached={fetchMore}
          ListEmptyComponent={() =>
            item.comments.fetch.isError ? <EmptyResultView /> : null
          }
          onPressUser={onPressUser}
        />
      </Container>
    );
  });
